export default {
  gTagData: (state) => state.gTagData
}